import {
    IdCardWrapper,
    TitleAndCommandsWrapper,
    TitlesWrapper,
    IdCardTitle,
    ModuleTitle,
    CommandsWrapper,
    PrintButton,
    ExitButton,
    EditButton,
    DetailsWrapper,
    TextualDetailsWrapper,
    VisualDetailsWrapper,
    SectionTitle,
    SectionTitleEmbedded,
    ImagesWrapper,
    ImageWrapper,
    CharacteristicsAndModulesWrapper,
    CharacteristicsWrapper,
    CharacteristicsSectionWrapper,
    CharacteristicWrapper,
    CharacteristicTitle,
    CharacteristicValue,
    ModulesWrapper,
    ModuleWrapper,
    ModuleImage,
    ModuleNameWrapper,
    ModuleTsCode,
    ModuleName,
    SubMenusWrapper,
    SectionTitleEl,
    SlotLoaderContainer,
} from './styles';

import Description from '../../Description';
import ImageViewer from '../../ImageViewer';
import SubMenuItem from '../../SubMenuItem';
import DocumentationList from '../../DocumentationList';
import Loader from '../../../components/Loader';
import NotFound from '../../../screens/NotFound';

import { user_roles, CONTRACT_TYPE_OPTIONS, MOORING_SYSTEM_OPTIONS } from '../../../config/enums';
import { useUser } from '../../../context/user';
import { useIdCard } from '../../../screens/HomeScreen/context/idCard';
import { useIdCatalogSearch } from '../../SideMenuSearchLane/context';
import { useState } from 'react';
import EditIdCardModal from '../../EditIdCardModal';

const testData = {
    id: "4028c4ea87035218018703522fb300a9",
    createdAt: 1679387930.548,
    modifiedAt: 1679387930.548,
    version: 1,
    previousVersionId: null,
    revision: null,
    projectId: "4028828480db7f030180db7f09770002",
    projectNr: '12345',
    projectName: 'Super FPSO',
    projectClient: 'Client name',
    projectLocation: 'Somewhere in the Atlantic',
    description: 'This was the coolest project I\'ve worked on',
    scopeOfWork: 'item 1\nitem 2\nitem 3',
    documents: ['doc 1', 'doc 2', 'doc 3'],
    contractType: 'Lease',
    contractDuration: "2 years",
    mooringSystem: 'Turret moored',
    conversionYard: 'something',
    integrationYard: 'something',
    nrProductionRisers: 4,
    nrGasRisers: 5,
    nrWaterRisers: 12,
    hullDimensions: 'LxBxHxT',
    maxPob: 100,
    fieldName: 'something',
    distanceFromShore: 100,
    waterDepth: 333,
    fieldSpecifics: 'something',
    crudeOilViscosity: 31,
    gasBlanketing: true,
    storageCapacity: 300,
    processCapacity: 'something',
    modules: [{
        "id": "ff8080818587929801858793c7ac0000",
        "tagId": "ff8080818587929801858793c7ac0000",
        "imageId": null,
        "name": "Riser Manifold",
        "tsCode": "TS041",
        "description": "A cool riser manifold for your convenience",
        "project": "5 - Prosperity",
        "client": null,
        "fpso": false
    }],
};

const Project = ({ projectData }) => {
    const { user } = useUser();
    const { idCard: idCardData, isLoading: isCardLoading } = projectData;
    const { removeCatalogItem, addCatalogItem } = useIdCatalogSearch();
    const { setEditingCardTagId, setPrintMode, setIsProjectIdCard } = useIdCard();
    const [isEditModalOpened, setIsEditModalOpened] = useState(false);
    let images = [4];
    idCardData?.images.forEach(i => {
        images[i.indexNr] = i;
    });

    const shouldRenderNotFound = !Boolean(idCardData) && !isCardLoading;
    const shouldRenderLoader = isCardLoading;

    const onEditCard = () => {
        setEditingCardTagId(idCardData.projectId);
        setIsEditModalOpened(true);
        setIsProjectIdCard(true);
    };

    const getContractType = (contractType) => {
        if (contractType) {
            return CONTRACT_TYPE_OPTIONS.filter(t => t.value === contractType)[0].label;
        }
        return '';
    };

    const getMooringSystem = (mooringSystem) => {
        if (mooringSystem) {
            return MOORING_SYSTEM_OPTIONS.filter(t => t.value === mooringSystem)[0].label;
        }
        return '';
    };

    return <IdCardWrapper>
            {shouldRenderNotFound ? (
                <NotFound />
            ) : shouldRenderLoader ? (
                <SlotLoaderContainer>
                    <Loader />
                </SlotLoaderContainer>
            ) : (
                <>
                    <CommandsWrapper>
                        <PrintButton
                            title='Print Card'
                            onClick={() => setPrintMode(true)}
                        />

                        {(user.roles.includes(user_roles.admin) || user?.roles.includes(user_roles.catalogAdmin) || user?.roles.includes(user_roles.castAdmin)) && (
                            <EditButton
                                title='Edit Card'
                                onClick={() => onEditCard()}
                            />
                        )}
                        <ExitButton onClick={() => removeCatalogItem(idCardData.projectId)} />
                    </CommandsWrapper>
                    <TitleAndCommandsWrapper>
                        <TitlesWrapper>
                            <IdCardTitle>
                                <SectionTitleEl>{`${idCardData.projectNr ? idCardData.projectNr : ''} - ${idCardData.projectName ? idCardData.projectName : ''}`}</SectionTitleEl>
                            </IdCardTitle>
                            <ModuleTitle>
                                <SectionTitleEl>{`${idCardData.projectClient ?? ''}`}</SectionTitleEl>
                            </ModuleTitle>
                            <ModuleTitle>
                                <SectionTitleEl>{`${idCardData.projectLocation ?? ''}`}</SectionTitleEl>
                            </ModuleTitle>
                        </TitlesWrapper>
                    </TitleAndCommandsWrapper>

                    <DetailsWrapper>
                        <TextualDetailsWrapper>
                            <SectionTitle>Description:</SectionTitle>
                            <Description description={idCardData.description ?? ''} />
                            <SectionTitleEmbedded>SBM scope of work:</SectionTitleEmbedded>
                            <Description description={idCardData.scopeOfWork ?? ''} />
                        </TextualDetailsWrapper>

                        <VisualDetailsWrapper>
                            <ImageViewer
                                imageId={images[0] ? images[0].imageId : ''}
                                fullscreen={true}
                                defaultLoaderSize={75}
                                containerStyle={{
                                    width: '100%',
                                    height: '100%',
                                }}
                            />
                        </VisualDetailsWrapper>
                    </DetailsWrapper>
                    <ImagesWrapper>
                        <ImageWrapper>
                            <SectionTitle>General Arrangement:</SectionTitle>
                            <ImageViewer
                                imageId={images[1] ? images[1].imageId : ''}
                                fullscreen={true}
                                defaultLoaderSize={75}
                                containerStyle={{
                                    width: '100%',
                                    height: '100%',
                                }}
                            />
                        </ImageWrapper>
                        <ImageWrapper>
                            <SectionTitle>Process Overview:</SectionTitle>
                            <ImageViewer
                                imageId={images[2] ? images[2].imageId : ''}
                                fullscreen={true}
                                defaultLoaderSize={75}
                                containerStyle={{
                                    width: '100%',
                                    height: '100%',
                                }}
                            />
                        </ImageWrapper>
                        <ImageWrapper>
                            <SectionTitle>Field layout:</SectionTitle>
                            <ImageViewer
                                imageId={images[3] ? images[3].imageId : ''}
                                fullscreen={true}
                                defaultLoaderSize={75}
                                containerStyle={{
                                    width: '100%',
                                    height: '100%',
                                }}
                            />
                        </ImageWrapper>
                    </ImagesWrapper>
                    <CharacteristicsAndModulesWrapper>
                        <CharacteristicsWrapper>
                            <CharacteristicsSectionWrapper>
                                <SectionTitle>Project characteristics:</SectionTitle>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Contract type:</CharacteristicTitle>
                                    <CharacteristicValue>{getContractType(idCardData.contractType)}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Contract duration:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.contractDuration}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Mooring system:</CharacteristicTitle>
                                    <CharacteristicValue>{getMooringSystem(idCardData.mooringSystem)}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Integration yard:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.integrationYard}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Nr production risers:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.nrProductionRisers}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Nr gas risers:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.nrGasRisers}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Nr gas export risers:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.nrGasExportRisers}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Nr water risers:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.nrWaterRisers}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Hull dimensions (LxWxH):</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.hullDimensions} m</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Max POB:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.maxPob}</CharacteristicValue>
                                </CharacteristicWrapper>
                            </CharacteristicsSectionWrapper>
                            <CharacteristicsSectionWrapper>
                                <SectionTitle>Field characteristics:</SectionTitle>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Field name:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.fieldName}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Distance from shore:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.distanceFromShore} km</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Water depth:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.waterDepth} m</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Field specifics:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.fieldSpecifics}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Crude oil viscosity:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.crudeOilViscosity} °API</CharacteristicValue>
                                </CharacteristicWrapper>
                            </CharacteristicsSectionWrapper>
                            <CharacteristicsSectionWrapper>
                                <SectionTitle>FPSO characteristics:</SectionTitle>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Gas blanketing:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.gasBlanketing ? 'Yes' : 'No'}</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Storage capacity:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.storageCapacity} m3</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Oil production:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.oilProduction} bpd</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Water production:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.waterProduction} bpd</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Total liquid:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.totalLiquid} bpd</CharacteristicValue>
                                </CharacteristicWrapper>
                                <CharacteristicWrapper>
                                    <CharacteristicTitle>Gas production:</CharacteristicTitle>
                                    <CharacteristicValue>{idCardData.gasProduction} MM scfd</CharacteristicValue>
                                </CharacteristicWrapper>
                            </CharacteristicsSectionWrapper>
                        </CharacteristicsWrapper>
                        <ModulesWrapper>
                            <SectionTitle>Modules:</SectionTitle>
                            {idCardData.modules && idCardData.modules.map(module =>
                                <ModuleWrapper onClick={() => addCatalogItem(module.tagId, false)} key={module.tagId}>
                                    <ModuleImage>
                                        <ImageViewer
                                            imageId={module.imageId}
                                            fullscreen={false}
                                            defaultLoaderSize={35}
                                            containerStyle={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                        />
                                    </ModuleImage>
                                    <ModuleNameWrapper>
                                        <ModuleTsCode>{module.tsCode}</ModuleTsCode>
                                        <ModuleName>{module.name}</ModuleName>
                                    </ModuleNameWrapper>
                                </ModuleWrapper>
                            )}
                        </ModulesWrapper>
                    </CharacteristicsAndModulesWrapper>
                    <SubMenusWrapper>
                        <SubMenuItem
                            title={'Documentation List'}
                            component={<DocumentationList documents={idCardData.documents} isProject={true}/>}
                        />
                    </SubMenusWrapper>
                </>
            )}
            {isEditModalOpened && (
                <EditIdCardModal
                    isEditMode={true}
                    onModalClose={() => setIsEditModalOpened(false)}
                    isProjectCard={true}
                />
            )}
        </IdCardWrapper>
};

export default Project;
